import React from 'react';
import { scroller } from 'react-scroll';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import scrollToOptions from '../../../Utils/scrollToOptions';
import useWidth from '../../../Hooks/useWidth';

function ScrollToAnswerButton() {
  const isMobile = useWidth('down', 'sm');

  const scrollToAdminResponse = () => {
    scroller.scrollTo('admin_response', { ...scrollToOptions, offset: -200 });
  };

  return (
    <Button
      size="large"
      variant="outlined"
      color="primary"
      fullWidth={isMobile}
      onClick={scrollToAdminResponse}
    >
      <FormattedMessage id="BUTTONS.VIEW_ANSWER" />
    </Button>
  );
}

export default ScrollToAnswerButton;
